/**
 * Active directory account information
 */
export interface AccountInfo {
    name: string;
    type: string;
}
